import { j as i } from "./jsx-runtime.DGlMoOmv.js";
import { S as y } from "./index.B4ZV02se.js";
import * as d from "react";
import { useFormContext as I, FormProvider as h, Controller as j } from "react-hook-form";
import { L as b } from "./Label.h3I9kFDT.js";
import { c } from "./index.CxSWpsOB.js";
const x = d.createContext({}), F = d.createContext({}), f = () => {
  const e = d.useContext(F), o = d.useContext(x), {
    getFieldState: s,
    formState: t
  } = I(), r = s(e.name, t);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const {
    disabled: m,
    readOnly: n
  } = o, a = e.name.replace(/\./g, "-");
  return {
    id: a,
    name: e.name,
    disabled: m,
    readOnly: n,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...r
  };
}, H = ({
  className: e,
  onSubmit: o,
  fullWidth: s,
  children: t,
  spacing: r = 24,
  noValidate: m = !0,
  testId: n,
  id: a,
  ...l
}) => /* @__PURE__ */ i.jsx(h, { ...l, children: /* @__PURE__ */ i.jsx("form", { "data-testid": n, noValidate: m, id: a, className: c({
  "tw-w-full": s,
  "tw-space-y-16": r === 16,
  "tw-space-y-24": r === 24,
  "tw-space-y-32": r === 32
}, e), onSubmit: o, children: t }) }), O = ({
  ...e
}) => /* @__PURE__ */ i.jsx(F.Provider, { value: {
  name: e.name
}, children: /* @__PURE__ */ i.jsx(j, { ...e }) }), C = d.forwardRef(({
  disabled: e,
  readOnly: o,
  className: s,
  ...t
}, r) => /* @__PURE__ */ i.jsx(x.Provider, { value: {
  disabled: e,
  readOnly: o
}, children: /* @__PURE__ */ i.jsx("div", { ref: r, className: c("tw-space-y-8", s), ...t }) }));
C.displayName = "FormItem";
const N = d.forwardRef(({
  subcopy: e,
  className: o,
  children: s,
  ...t
}, r) => {
  const {
    formItemId: m,
    disabled: n
  } = f();
  return /* @__PURE__ */ i.jsxs("div", { children: [
    /* @__PURE__ */ i.jsx(b, { ref: r, className: c({
      "tw-text-gray-500": n
    }, o), htmlFor: m, ...t, children: s }),
    e && /* @__PURE__ */ i.jsx(g, { children: e })
  ] });
});
N.displayName = "FormLabel";
const p = "quoteHighlight", v = d.forwardRef(({
  forwardErrorMsg: e = !1,
  ...o
}, s) => {
  const {
    error: t,
    disabled: r,
    readOnly: m,
    formItemId: n,
    formDescriptionId: a,
    formMessageId: l
  } = f(), u = t?.type === p, w = t ? u ? "​" : t.message ?? void 0 : void 0;
  return /* @__PURE__ */ i.jsx(y, { ref: s, id: n, disabled: r, ...e && {
    errorMsg: w
  }, readOnly: m, "aria-describedby": t ? `${a} ${l}` : `${a}`, "aria-invalid": !!t, ...o });
});
v.displayName = "FormControl";
const g = d.forwardRef(({
  className: e,
  ...o
}, s) => {
  const {
    formDescriptionId: t,
    disabled: r
  } = f();
  return /* @__PURE__ */ i.jsx("p", { ref: s, id: t, className: c("tw-body-1 tw-text-gray-600", {
    "tw-text-gray-500": r
  }, e), ...o });
});
g.displayName = "FormDescription";
const M = d.forwardRef(({
  className: e,
  children: o,
  ...s
}, t) => {
  const {
    error: r,
    formMessageId: m,
    disabled: n
  } = f(), a = r?.type === p, l = a ? o : r ? String(r.message) : o;
  return l ? /* @__PURE__ */ i.jsx("p", { ref: t, id: m, className: c("tw-caption-2 tw-text-gray-600", {
    "tw-text-gray-500": n,
    "tw-text-red-800": !!r && !a
  }, e), ...s, children: l }) : null;
});
M.displayName = "FormMessage";
export {
  p as F,
  H as a,
  v as b,
  g as c,
  O as d,
  C as e,
  N as f,
  M as g,
  x as h,
  F as i,
  f as u
};
//# sourceMappingURL=Form.LdCd9gH2.js.map
